module.exports = __webpack_public_path__ + "img/stadia-ios-homepage-pwa-framed_2x.3ed53cd2.webp";